import React, { useState, useEffect, Fragment, useRef } from "react";
import _ from 'lodash';
import Loader from "react-js-loader";
import "./CalendarScreen.css";
import HeaderScreen from "../HeaderScreen/HeaderScreen";
import { RxCountdownTimer } from "react-icons/rx";
import { Card, Modal, Button } from 'react-bootstrap';
import { Calendar, momentLocalizer } from 'react-big-calendar';
// import dayjs from 'dayjs'
import moment from 'moment'
import 'moment-timezone';
import { Toast } from 'primereact/toast';
import { API_URL, getAuthUserFromSessionStorage, isDateGreaterThanToday } from "../../common/constant";
import CustomWeekView from "./CustomWeekView";
import "react-big-calendar/lib/css/react-big-calendar.css";

const CalendarScreen = () => {
    // moment.tz.setDefault('Asia/Kolkata')

    const twoMonthsAgo = moment().subtract(2, 'months').toDate();
    const today = new Date();

    const toast = useRef(null);

    const localizer = momentLocalizer(moment);
    const [isLoading, setIsLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [userDetails, setUserDetails] = useState(getAuthUserFromSessionStorage());
    const [isDragging, setIsDragging] = useState(false);
    const [showDeleteSlotModal, setShowDeleteSlotModal] = useState(false);
    const [selectedEventToDelete, setSelectedEventToDelete] = useState(null);

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 7);

    useEffect(() => {
        fetchBooking()
    }, [])

    const fetchBooking = () => {
        fetch(`${API_URL}api/getSlots/${userDetails.id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${userDetails.token}`,
            }
        })
            .then((response) => response.json())
            .then((response) => {
                const myEvents = [];
                response.map((item) => {
                    if (new Date(item.start) > twoMonthsAgo) {
                        myEvents.push(
                            {
                                id: item._id,
                                title: item.title,
                                start: new Date(item.start),
                                end: new Date(item.end)
                            }
                        )
                    }
                })
                setEvents(myEvents)
            })
            .catch((err) => {
                setEvents([]);
            });
    }

    // Add this new function to check for overlapping slots
    const hasOverlappingSlots = (start, end) => {
        const startTime = new Date(start);
        const endTime = new Date(end);
        
        return events.some(event => {
            const eventStart = new Date(event.start);
            const eventEnd = new Date(event.end);
            
            // Check if the new slot overlaps with any existing slot on the same day
            const sameDay = startTime.toDateString() === eventStart.toDateString();
            
            if (sameDay) {
                // Check for overlap: new slot starts before existing slot ends AND new slot ends after existing slot starts
                return (startTime < eventEnd && endTime > eventStart);
            }
            
            return false;
        });
    };

    const handleSelect = ({ start, end }) => {
        const timeDifference = end.getTime() - start.getTime();
        const minutesDifference = (timeDifference / 1000) / 60;

        // Specified date
        let specifiedDate = new Date(start);
        // Current date
        let currentDate = new Date();
        // Calculate the difference in milliseconds
        let differenceInMilliseconds = specifiedDate - currentDate;
        // Convert the difference to days, hours, minutes, and seconds
        let differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
        let differenceInMinutes = Math.floor(differenceInSeconds / 60);
        let differenceInHours = Math.floor(differenceInMinutes / 60);
        let differenceInDays = Math.floor(differenceInHours / 24);

        if (differenceInDays <= 15) {
            if (new Date(start).getTime() < new Date().getTime()) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'You can not book past date slots', life: 3000 });
                setIsDragging(false);
            } else {
                // Check for overlapping slots before proceeding
                if (hasOverlappingSlots(start, end)) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'A slot already exists for this time period. Please choose a different time.', life: 3000 });
                    setIsDragging(false);
                    return;
                }

                const title = "Available";
                if (isDragging) {
                    if (minutesDifference >= 30 && minutesDifference <= 45) {
                        const newEvent = {
                            start: start,
                            end: end,
                            title: title,
                            userId: userDetails.id
                        };
                        bookSlot(newEvent)
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please note that you can only book a slot between 30 to 45 minutes. Ensure your selected time falls within this rang', life: 3000 });
                    }
                    setIsDragging(false);
                } else {
                    const addedEndTimeData = new Date(start.getTime() + 45 * 60000);
                    const newEvent = {
                        start: start,
                        end: addedEndTimeData,
                        title: title,
                        userId: userDetails.id
                    };
                    bookSlot(newEvent)
                    setIsDragging(false);
                }
            }
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Sorry, you can\'t book a slot for more than 15 days ahead.', life: 3000 });
        }
    };

    const bookSlot = (newEvent) => {
        fetch(`${API_URL}api/bookSlots`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            },
            body: JSON.stringify(newEvent)
        })
            .then((response) => response.json())
            .then((response) => {
                fetchBooking()
            })
            .catch((err) => {

            });
    }

    const handleSelectSlot = (event) => {
        if (event.title === "Available" && isDateGreaterThanToday(event.start)) {
            setSelectedEventToDelete(event);
            setShowDeleteSlotModal(true);
        }
    };

    const confirmDeleteSlot = () => {
        if (selectedEventToDelete) {
            const index = events.findIndex((e) => e.id === selectedEventToDelete.id);
            if (index >= 0) {
                setEvents([...events.slice(0, index), ...events.slice(index + 1)]);
                deleteSlot(events[index].id)
            }
        }
        setShowDeleteSlotModal(false);
        setSelectedEventToDelete(null);
    };

    const deleteSlot = (id) => {
        fetch(`${API_URL}api/deleteSlot/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${userDetails.token}`,
            }
        })
            .then((response) => response.json())
            .then((response) => {
                fetchBooking()
            })
            .catch((err) => {

            });
    }

    const handleDragStart = () => {
        setIsDragging(true);
    };

    const dayPropGetter = (date) => {
        if (date < twoMonthsAgo) {
            return {
                className: 'disabled-date',
                style: {
                    backgroundColor: '#f0f0f0',
                    color: '#d0d0d0',
                    pointerEvents: 'none',
                },
            };
        }
        return {};
    };

    return (
        <Fragment>
            <Toast ref={toast} />
            {
                isLoading &&
                <div className="spinner-loader">
                    <Loader type="spinner-circle" bgColor="#2F2F74" color="#2F2F74" size={100} />
                </div>
            }

            {/* Delete Slot Confirmation Modal */}
            <Modal show={showDeleteSlotModal} onHide={() => {
                setShowDeleteSlotModal(false);
                setSelectedEventToDelete(null);
            }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this slot?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => confirmDeleteSlot()}>Yes</Button>
                    <Button variant="outline-primary" onClick={() => {
                        setShowDeleteSlotModal(false);
                        setSelectedEventToDelete(null);
                    }}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            <div className="container-fluid calendar-container fixed-padding">
                <div className="row">
                    <div className="col-12 px-0">
                        <HeaderScreen />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 my-auto calendar-title pageTitle_fixed">
                        <RxCountdownTimer size={20} className="header-icon" />CALENDAR
                    </div>
                </div>
                <div className="row calendar-feednback-row">

                    <div className="col-12">
                        <Card>
                            <Card.Body>
                                <Calendar
                                    // views={["day", "work_week", "month"]}
                                    views={{ day: true, work_week: CustomWeekView, month: true }}
                                    selectable
                                    localizer={localizer}
                                    step={15}
                                    formats={{
                                        dayFormat: "ddd"
                                    }}
                                    defaultDate={new Date()}
                                    defaultView="day"
                                    events={events}
                                    style={{ height: "100vh" }}
                                    onSelectEvent={handleSelectSlot}
                                    onSelectSlot={handleSelect}
                                    onSelecting={handleDragStart}
                                    dayPropGetter={dayPropGetter}
                                />
                            </Card.Body>
                        </Card>
                    </div>

                </div>
            </div>
        </Fragment>
    )
}
export default CalendarScreen;



